import { createConstants } from '../_helpers/utils'

export const contentTypes = createConstants(
    'PAGE_DATA_REQUEST',
    'PAGE_DATA_SUCCESS',
    'PAGE_DATA_FAILURE',
    'MENU_DATA_REQUEST',
    'MENU_DATA_SUCCESS',
    'TESTIMONIAL_LIST_REQUEST',
    'TESTIMONIAL_LIST_SUCCESS',
    'CLEAR_PAGE',
    'TOGGLE_MENU',
)
